import styled from "styled-components/macro";

import {
  borderRadius,
  boxShadow,
  colors,
  fontStyle,
  space,
} from "shared/styles/constants";
import { motion } from "framer-motion";
import { IStatus } from "shared/types";
import { getStatus } from "shared/styles/defaults";

export const ToastContainer = styled(motion.div)`
  display: flex;
  align-items: center;

  width: fit-content;
  padding: ${space.xs};
  margin-right: auto;
  margin-left: auto;

  ${fontStyle.bold}
  color: ${colors.black};

  background-color: ${colors.white};
  box-shadow: ${boxShadow.m};
  border-radius: ${borderRadius.s};

  line-height: 1;
`;

interface ToastIconProps {
  status?: IStatus;
}

export const ToastIcon = styled.div<ToastIconProps>`
  svg {
    color: ${({ status }) => getStatus(status).iconColor || "currentColor"};
  }
`;

export const ToastMessage = styled.p`
  &::first-letter {
    text-transform: uppercase;
  }
`;
